export default __webpack_public_path__ + "pgnv-assets/48fa6c940e72a44b89e2e151ec58cc8c.png";